const KeenSlider = window.KeenSlider

const { setInitialised, useAutoplay } = window.BAO.Carousel.plugins

class TestimonialsCarousel extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    if (this.els.slide.elements.length < 2) return

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    this.onSlideChanged = this.onSlideChanged.bind(this)

    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: true,
        renderMode: 'custom',
        slides: {
          perView: 1,
          spacing: 0,
        },
        slideChanged: this.onSlideChanged,
      },
      [setInitialised(), useAutoplay(4, { pauseOnHover: true })],
    )
  }

  onSlideChanged (instance) {
    this.updateProgressBar(instance)
    this.updateCurrentSlide(instance)
  }

  updateProgressBar (instance) {
    const currentSlide = instance.track.details.rel
    const slidesLength = instance.track.details.slidesLength
    const movementPercentage = (currentSlide / slidesLength) * 100

    this.els?.progress?.element?.style.setProperty(
      '--Testimonials_Progress',
      `${movementPercentage}%`,
    )
  }

  updateCurrentSlide (instance) {
    const currentSlide = instance.track.details.rel

    this.els?.slide?.elements?.forEach((slide, index) => {
      slide.setAttribute('aria-hidden', index !== currentSlide)
    })
  }
}

if (!customElements.get('testimonials-carousel')) {
  customElements.define('testimonials-carousel', TestimonialsCarousel)
}
